const generalSettings = require("/home/forge/doit.uw.edu/build/frontend/generalSettings.json");
const nodesConfig = require("/home/forge/doit.uw.edu/build/frontend/nodesConfig.json");
const sortOptions = require("/home/forge/doit.uw.edu/build/frontend/sortOptions.json");
const themeConfig = require("/home/forge/doit.uw.edu/build/frontend/themeConfig.js");
const customScripts = require("/home/forge/doit.uw.edu/build/frontend/customScripts.json");
const absPath = "/home/forge/doit.uw.edu/build/frontend";
module.exports = {
  generalSettings,
  nodesConfig,
  sortOptions,
  themeConfig,
  customScripts,
  absPath,
};
